export default __webpack_public_path__ + "static/nara_logo_720_r-9758b342f8af8e0e5cbcee41d2a641d1.webp";